function DashboardSection({
  title,
  description,
  action,
  children,
  className = "",
}) {
  return (
    <section
      className={["dashboard-section", className]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="dashboard-section__header">
        <div>
          <h2>{title}</h2>

          {description ? (
            <p>{description}</p>
          ) : null}
        </div>

        {action ? (
          <div className="dashboard-section__action">
            {action}
          </div>
        ) : null}
      </div>

      <div className="dashboard-section__content">
        {children}
      </div>
    </section>
  );
}

export default DashboardSection;